/**
 * Msg 590 · Phase A — Icon resolver keyed on `category_id`.
 *
 * The pre-Phase-A hard-coded `entity_type` → icon map was retired.
 * Icons now come from user-defined categories in the `atlas_categories`
 * collection. Given a topic's `category_id`, we look up the category
 * from the client-side cache (`atlasCategoriesCache.js`) and return
 * the lucide component for its `icon_name`. Anything unresolved
 * falls back to `Folder` — never crashes, never renders nothing.
 *
 * Legacy call sites that pass `entity_type` continue to work: they
 * silently resolve to `Folder`, which is acceptable behavior while
 * admins are still populating categories.
 */
import { Folder } from "lucide-react";
import { getCategoryById } from "./atlasCategoriesCache";
import { iconByName } from "./topicIconMap";


/**
 * Resolve the icon component for a topic.
 *
 * New primary signature: `getTopicIcon(topicOrCategoryId)`
 *   - Pass the topic object (uses `topic.category_id`), OR
 *   - Pass a `category_id` string directly.
 *
 * Legacy signature: `getTopicIcon(entity_type, category)` still
 * returns `Folder` for anything so callers that haven't been
 * migrated yet render the generic icon.
 */
export function getTopicIcon(topicOrId) {
  if (!topicOrId) return Folder;
  const catId = typeof topicOrId === "string"
    ? topicOrId
    : (topicOrId.category_id || null);
  if (!catId) return Folder;
  const cat = getCategoryById(catId);
  if (!cat) return Folder;
  return iconByName(cat.icon_name);
}
